module.exports = __webpack_public_path__ + "bd13c43f8bdf07ff655aa5aa138e1d41.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/waller-geschaftsleute.svg
// module id = 947
// module chunks = 0